export default {
  txt_welcome: 'Bienvenue à utiliser le détecteur intelligent de pneus Tyrehub',
  txt_dataover: 'Aperçu des données',
  txt_chance: 'Opportunités',
  txt_device: 'Appareil',
  txt_chinese: '中文',
  txt_english: '英文',
  txt_malay: '马来语',
  txt_german: '德语',
  txt_french: '法语',
  txt_italian: '意大利语',
  txt_spanish: '西班牙语',
  txt_reports: 'Historique',
  txt_setting: 'Réglage',
  txt_dymanager: 'Gestion des employés',
  txt_account: 'No. de compte',
  txt_userstatus: "Identité d'utilisateur",
  txt_name: 'Nom',
  txt_contactway: 'Numéro de téléphone',
  txt_accountsafe: "Sicurezza dell'account",
  txt_basicinfo: 'Information basique',
  txt_updatepassword: 'Modifier le mot de passe',
  txt_storeinfomation: 'Information de boutique',
  txt_storename: 'Nom de boutique',
  txt_storephone: 'Numéro de téléphone de boutique',
  txt_storeaddress: 'Adresse de boutique',
  txt_AppInfomation: 'App',
  txt_currentversion: 'No. de version',
  txt_software: 'Mise à jour de logiciel',
  txt_loginout: 'Déconnexion',
  txt_updatelanguage: 'Langage',
  txt_updateto: 'Aggiornamento alla',
  txt_zwgx: 'Nessun aggiornamento',
  txt_dz: 'Manager de boutique',
  txt_sh: 'merchant',
  txt_dy: 'Gestion des employés',
  txt_bdsj: 'Lier le téléphone mobile',
  txt_shxx: 'Information de marchand',
  txt_shname: 'Nom de marchand',
  txt_ssmd: 'Magasin',
  txt_bdsb: 'Appareil lié',
  txt_mendian: 'Magasin',


  //数据总览模块
  txt_sTime: 'Période choisie',
  txt_car_check: 'Taux de détection des véhicules',
  txt_findchance: 'Opportunités de vente',
  txt_trackchace: "Suivi d'opportunités",
  txt_transform: 'Taux de conversion',
  txt_TotalData: 'Aperçu des données',
  txt_xxsj: 'Données détaillées',
  txt_zhsj: 'Nombre de conversions',
  txt_TireWear: 'Usure des pneus',
  txt_DataHopper: 'Imbuto di dati',
  txt_jdcc: 'Trafic des véhicules',
  txt_CheckCar: 'Nombre de détections',
  txt_ChanceNum: 'Opportunités',
  txt_TrackNum: 'Nombre de suivis',
  txt_TranseformNum: 'Nombre de conversions',
  txt_UnTrack: 'Non suivi',
  txt_l: 'Distribuzione ',
  txt_Time: 'Durée',
  txt_Device: 'Appareil',
  txt_car_plate: 'Targa',
  txt_Wear: 'Usure anormale',
  txt_Pwear: 'Usure inégale',
  txt_NoData: 'Nessun dato',
  txt_GoodState: 'Normal',
  txt_Border: 'Limite',
  txt_replace: 'Remplacez immét.',
  txt_Total_Check: 'Veicoli rilevati totali',
  txt_pmqk: 'Usure inégale',
  txt_LightWear: 'Leggera usura parziale',
  txt_GraveWear: 'Grave usura parziale',
  txt_hwtj: 'Interchangement&Equilibre dynamique',
  txt_wxhw: "Pas besoin d'interchanger",
  txt_xyhw: "Besoin d'interchanger",
  txt_jcxq: 'Données détaillées',
  txt_zhxq: 'Détail de conversion',
  txt_cc: 'véhicules',
  txt_bfb: '%',
  txt_ltxs: 'Vente de pneus',
  txt_sldw: 'Alignement de 4-roues',
  txt_ddlph: 'Interchangement&Equilibre dynamique',
  txt_dphhh: 'Equilibre dynamique',
  txt_qt: 'Autres',
  txt_zhqs: 'Tendance de conversion',
  txt_ltxl: 'Vente de pneus',
  txt_ltfw: 'Service de pneu',
  txt_ckxq: 'Données détaillées',
  txt_jt: "Aujourd'hui",
  txt_zt: 'Hier',
  txt_bz: 'Cette semaine',
  txt_by: 'Ce mois',
  txt_sy: 'Dernier mois',
  txt_jn: 'Cette année',
  txt_zhcl: 'Quantité de conversion (véhicules)',
  txt_zhl: 'Taux de conversion',
  txt_bfb: '%',
  txt_abjx: 'Répartition des pneus de « Etat de limite »',
  txt_aljg: 'Répartition des pneus de « Remplacer immédiat. »',
  txt_qwpm: 'Répartition des pneus de « Légère usure inégale »',
  txt_ayzp: 'Répartition des pneus de « Grave usure inégale »',
  txt_lingt: '0 pneumatico',
  txt_yt: '1 pneumatico',
  txt_et: '2 pneumatici',
  txt_st: '3 pneumatici',
  txt_ft: '4 pneumatici',

  //机会
  txt_xsjh: 'Opportunités',
  txt_gzz: 'En cours de suivi',
  txt_clwb: 'Traitement terminé',
  txt_ckbg: 'Rapport de contrôle',
  txt_yxs: 'Toutes les données ont été affichées',
  txt_zhuiz: 'Rappel',
  txt_tix: 'pour suivi',
  txt_chuli: 'Affronta',
  txt_yzh: 'Converti',
  txt_wzh: 'Non converti',
  txt_gzsmts: '{0} le pneu a quelques problèmes，{1} ira en magasin pour réparation.',
  txt_czbty: 'Disconvenu',
  txt_yyx: 'Intention',
  txt_ltyg: '1 pneumatico',
  txt_ltkg: '2 pneumatici',
  txt_ltsang: '3 pneumatici',
  txt_ltsig: '4 pneumatici',
  txt_jhcl: "Elaborazione dell'opportunità",
  txt_jhztai: "Etat d'opportunité",
  txt_crquy: 'Région ',
  txt_chuliry: 'Traité par ',
  txt_chulijg: 'Résultat',
  txt_zhuanhuanr: 'Contenu de conversion',
  txt_zhuanhuaje: 'Montant de conversion',
  txt_zhuanhuasj: 'Temps de conversion',
  txt_zhuanhuayx: 'Temps estimé',
  txt_xuanzesj: 'Durée',
  txt_tsdatawk: "Lo stato dell'opportunità è vuoto e i dati non possono essere salvati",
  txt_qtxzhsj: 'Per favore compila il tempo previsto del tempo di conversione ',
  txt_qtxzhnr: 'Per favore compila il contenuto di conversione',
  txt_qtxzhsj: 'Per favore compila il tempo di conversione',
  txt_sbts: 'Salvataggio dei dati fallito, per favore controlla la rete',


  //设备
  txt_sbgl: 'Gestion des appareils',
  txt_tj: 'Ajouter',
  txt_gdssb: 'Total dispositifs {0}',
  txt_sbbh: "Code d'appareil",
  txt_gjbb: 'Version de microprogramme',
  txt_tjsj: "Heure d'ajout",
  txt_zdgx: 'Aggiornamento automatico',
  txt_gxgj: 'Mise à jour de logiciel',
  txt_jieb: 'Délier',
  txt_sbtsxx: 'Esiste una nuova versione del firmware del dispositivo, fai clic sul pulsante Aggiorna firmware per aggiornare',
  txt_wjh: 'Non activés ',
  txt_lix: 'Hors ligne',
  txt_zaix: 'En ligne',
  txt_guz: 'Faute',
  txt_yijieb: 'Délié',
  txt_yihuis: 'Recyclé',
  txt_gxsbgj: 'Mise à niveau du dispositif',
  txt_gxsbgjts: 'Vous voulez mettre l’appareil à jour?',
  txt_socketdk: "La communication avec le serveur n'est pas établie, veuillez réessayer",
  txt_cscgts: 'Demande de mise à jour de microprogramme envoyée avec succès',
  txt_jbsb: 'Délier l’appareil',
  txt_jbsbts: "Êtes-vous sûr de délier l'appareil",
  txt_tscg: 'Avec succès',
  txt_zdgxgj: 'Mise à jour automatique',
  txt_gxgjts: "Êtes-vous sûr d'activer/désactiver la fonction de mise à jour automatique de microprogramme ?",
  txt_beiz: 'Remarques',
  txt_qtxbz: 'Veuillez saisir le commentaire',
  txt_bdsbts: 'Questa APP è usata solo per il dispositivo [Edizione Internazionale del ispezione dei Pneumatici Portatili], per favore assicurati che il modello del dispositivo che desideri associare sia corretto',
  txt_qdksb: 'Per favore accendi prima il dispositivo',
  txt_dksbts1: "1、1. Se si tratta di un nuovo dispositivo, dopo l'avvio, entrerà automaticamente nella guida di associazione",
  txt_dksbts2: '2、2. Se il dispositivo è stato associato ad altri negozi in precedenza, per favore fai clic su Dissocia il Dispositivo nel menu "Impostazioni" del dispositivo per dissociare. Dopo la dissociazione, il dispositivo entrerà automaticamente nella guida di associazione',
  txt_yjdksblw: 'Ho acceso il dispositivo e mi sono connesso alla rete',
  txt_xyb: 'Prochain',
  txt_qsclj: 'Code QR du Scan',
  txt_qscts1: 'Per favore usa il dispositivo portatile per scansionare il codice QR per connettere il dispositivo. Dopo che il codice è stato scansionato con successo, emetterà un suono "Di" e ti ricorderà che il codice è stato scansionato con successo.',
  txt_qscts2: 'Scanné avec succès',
  txt_sbtssmcg: 'Scanné avec succès',
  txt_ddsblw: 'In attesa che il dispositivo si connetta alla rete',
  txt_zznlbd: 'Appareil lié',
  txt_qszdd: 'Questo può richiedere decine di secondi, per favore aspetta un po',
  txt_bdcg: 'Appareil lié avec succès',
  txt_tjcg: 'Ajoutée avec succès',
  txt_tjcgts: "Félicitations, l'appareil a été ajouté avec succès. Veuillez noter  le nom de l'appareil pour une identification facile",
  txt_fhsblb: "Retour à la liste d'appareil",
  txt_jxtjsb: "Continuer à ajouter l'appareil",
  txt_bzmc: 'Dispositif d’observation',


  //检测记录
  txt_sx: 'Sélect.',
  txt_khsj: 'Téléphone portable du client',
  txt_cphm: "Numéro de plaque d'immatriculation",
  txt_cphm1: "Numéro de plaque d'immatriculation",
  txt_clxh: 'Modèle de véhicule',
  txt_xgbz: 'Modifica nota',
  txt_gtfjl: 'Total rapports  {0} ',
  txt_jcsj: 'Heure de détection',
  txt_jcsj1: 'Heure de détection',
  txt_xzkssj: "Seleziona l'ora di inizio",
  txt_xzjssj: "Seleziona l'ora di fine",
  txt_jcjg: 'Résultat',
  txt_msqk: 'Usure de sculpture',
  txt_jygh: 'Remplacer',
  txt_zysh: 'Limites',
  txt_zcsy: 'Normal',
  txt_zc: 'Normal',
  txt_cz: 'Réinitialisation',
  txt_qd: 'Confirmez',
  txt_jcjgd: 'Résultat',
  txt_msqkd: 'Usure de sculpture',
  txt_sldwd: 'Alignement',
  txt_jyghd: 'Le remplacement est recommandé',
  txt_zysh: 'Fais attention.',
  txt_zcsyd: 'Normal',
  txt_xdwd: 'L’alignement est nécessaire',
  txt_xzyd: 'Fais attention',
  txt_zcd: 'Normal',
  txt_bgxq: 'Données détaillées',
  txt_ljdy: 'Imprimante',
  txt_fwmd: 'Boutique',
  txt_mddz: 'Adresse de boutique',
  txt_jcsb: 'Equipement de détection',
  txt_ddmd: 'But',
  txt_lic: 'Kilométrage',
  txt_chex: 'Type de véhicule',
  txt_jcjyi: 'Recommandations de détection',
  txt_ysbs: "Description d'état d'usure",
  txt_ztms: 'Usure globale',
  txt_hwms: 'Usure inégale',
  txt_dqscjltx: 'Rappel de la distance de freinage actuelle',
  txt_bgxqts: ' Delete',
  txt_wxsmgz: 'Veuillez abonner au compte officiel de Tyhrhub par Wechat en scannant le code QR ',
  txt_hwmsjh: 'Usure de sculpture',
  txt_zqlun: 'Roue avant gauche',
  txt_zhlun: 'Roue avant droite',
  txt_yqlun: 'Roue arrière droite',
  txt_yhlun: 'Roue arrière gauche',
  txt_pingjunzhi: 'Moyenne',
  txt_guige: 'Taille',
  txt_gongli: 'KM',
  txt_ltwjc: 'Pneumatico non rilevato',
  txt_pinpai: 'Marque',
  txt_ltws: 'Dommage de pneu',
  txt_sewmts: 'Scan QR Code pour vérifier le rapport',
  txt_print: 'Print',





  //店员管理
  txt_xz: 'Ajouter un commis',
  txt_qy: 'Activé',
  txt_qyz: 'Activé',
  txt_ty: 'Désactivé',
  txt_yhzh: "Compte d'utilisateur",
  txt_lxfs: 'Numéro de téléphone',
  txt_cjsj: 'Tempo di creazione',
  txt_bjxx: "Éditer l'information de boutique",
  txt_xgmm: 'Modifier le mot de passe',
  txt_bgzt: "Changer l'état",
  txt_qdytjm: 'Être sûr de désactiver le compte?',
  txt_tjdy: 'Ajouter',
  txt_bjdyxx: "Éditer l'information de boutique",
  txt_zhxx: "Informazioni sull'account",
  txt_ygxm: 'Nom',
  txt_qtxygxm: "Per favore inserisci il nome dell'impiegato",
  txt_lxdh: 'Coordonnées',
  txt_qtxyglxdh: 'Numéro de téléphone',
  txt_dxyzm: 'Codice di verifica SMS',
  txt_qtxdxyzm: 'Per favore compila il codice di verifica SMS',
  txt_fsdx: 'Invia un SMS',
  txt_tjzh: 'Ajouter',
  txt_baocun: 'Save',
  txt_gtgygzh: 'Total {0} comptes',



  //登录
  txt_qdytcdlm: 'Prêt à déconnexion',
  txt_qx: 'Annuler',
  txt_dl: 'Accedi',
  txt_qsrzh: 'Veuillez saisir le numéro de compte ou le numéro de téléphone',
  txt_qsrmm: 'Per favore inserisci la password',
  txt_zcshzh: 'Registre de la marine marchande',
  txt_shzhwjmm: 'J’ai oublié passowrd',
  txt_yzdqmm: 'Vérifier le mot de passe actuel',
  txt_szxmm: 'Créer un nouveau mot de passe',
  txt_xgcg: 'Modifié avec succès',
  txt_qtxjmm: "Veuillez saisir l'ancien mot de passe",
  txt_yzzcsj: 'Vérifier le téléphone mobile inscrit',
  txt_qtxxmm: 'Veuillez entrer un nouveau mot de passe',
  txt_qzctxxmm: 'Répéter un nouveau mot de passe',
  txt_lcmmsrbyz: 'Les deux mots de passe sont incohérents',
  txt_gxnxgcg: 'Félicitations, le mot de passe a été modifié avec succès',
  txt_qljndxmm: 'N’oublie pas ton nouveau mot de passe',
  txt_fhgrzx: 'Retour au centre personnel',
  txt_fsyzm: 'Envoyer le code de vérification',
  txt_qtxzcsjh: 'Per favore inserisci il numero di telefono cellulare registrato',
  txt_qtxtxyzm: 'Veuillez saisir le code de vérification graphique',
  txt_qsryzm: 'Veuillez saisir le code de vérification',
  txt_qszhhmm: 'Veuillez saisir un nouveau mot de passe composé de 6 à 18 chiffres et lettres',
  txt_qzcsrmm: 'Veuillez saisir de nouveau le mot de passe',
  txt_lcmmbyz: 'Les deux mots de passe sont incohérents',
  txt_hdsy: 'Les deux mots de passe sont incohérents',
  txt_zcshh: 'Les deux mots de passe sont incohérents',
  txt_fhdl: "Retourner à la page d'inscription",
  txt_wlqqsb: 'Les deux mots de passe sont incohérents',
  txt_wczc: 'Inscription terminée',
  txt_wsts: "Veuillez compléter votre information détaillée de marchand avant l'utilisation",
  txt_qtxshmc: 'Les deux mots de passe sont incohérents',
  txt_shmc: 'Nom de marchand',
  txt_rgszjd: "ex : numéros de téléphone fixe, d'autre téléphone, de fax  de société, etc.",
  txt_qtlxfs: 'Autre contact',
  txt_kssy: 'Commencer à utiliser',
  txt_Pwear1: 'Usure inégale',
  txt_open: 'Ouvert',
  txt_close: 'Près',
  txt_srczhdmm: 'Remplissez le nouveau mot de passe',
  txt_kcfs: '{0}s',
  txt_xiugai: 'Modifica',
  txt_zzjzsj: 'Chargement',
  txt_bjshxx: "Éditer l'information de boutique",
  txt_chongxinhq: 'Renvoyer',
  txt_gaibangsj: 'Modifier téléphone mobile',
  txt_yanzhengjsj: 'Vérifiez l’ancien téléphone portable.',
  txt_bangdingxsj: 'Lier au nouveau téléphone portable',
  txt_yhqsyxsjdl: 'Veuillez vous connecter par un nouveau téléphone portable',



  //登录新
  txt_xzshenfen: 'Veuillez choisir votre rôle',
  txt_dlrolewz: 'Connexion',
  txt_qsrsjh: 'Per favore inserisci il tuo numero di telefono cellulare',
  txt_zhuce: "S'inscrire",
  txt_wanjimima: 'Mot de passe oublié',
  txt_wanshandzxx: 'Migliora le informazioni del responsabile del negozio',
  txt_qsrxm: 'Per favore inserisci il tuo nome',
  txt_qsrmdm: 'Per favore inserisci il nome del negozio',
  txt_qsrmdgddh: 'Per favore inserisci il numero fisso del negozio',
  txt_qsrmddz: 'Per favore inserisci il indirizzo del negozio',
  txt_qsrgsdz: "Inserisci l'indirizzo dell'azienda",
  txt_qsrxxdz: 'Per favore inserisci un indirizzo dettagliato',
  txt_tijiaocg: 'Invia con successo',
  txt_qsvbsylwmm: 'Mot de passe pas moins de 6 chiffres',
  txt_zhucerole: 'Créer un compte {0}',
  txt_qsrshh: "Per favore inserisci il numero dell'azienda",
  txt_qsrdzh: 'Per favore inserisci il numero del responsabile del negozio',
  txt_wsshhzl: "Migliora le informazioni sull'account dell'azienda",
  txt_wsdyhzl: 'Migliora le informazioni degli impiegati del negozio',
  txt_qsrshm: "Per favore inserisci il nome dell'azienda (nome della società)",
  txt_qsrshz: "Per favore inserisci il proprietario dell'azienda (responsabile)",
  txt_qsrzrqy: 'Entrez dans la zone de travail',
  txt_shanghudizhi: "Indirizzo dell'azienda",
  txt_yhycz: 'Compte ou numéro de téléphone déjà existe',
  txt_qsrzqdzh: 'Per favore inserisci il numero del responsabile del negozio corretto',
  txt_qsrzqshh: "Per favore inserisci il numero dell'azienda corretto",
  txt_xzmdcx: 'Seleziona la richiesta del negozio',



  //门店
  txt_mendianId: 'Magasin',
  txt_mendianmc: 'Nom du magasin',
  txt_mendiandz: 'Adresse de boutique',
  txt_mendiandh: 'Numéro de téléphone de boutique',
  txt_caozuo: 'Opera',
  txt_mendiangl: 'Gestion de boutique',
  txt_gjmendian: ' Total {0} magasins',
  txt_zhengchangyy: 'En service',
  txt_tingye: 'Hors service',
  txt_gengdxx: 'Plus',
  txt_dianygl: 'Gestion des employés',
  txt_biangzt: "Changer l'état",
  txt_qdygbzhuangtai: 'Assurez-vous de désactiver le magasin.？',
  txt_bjmendian: "Éditer l'information de boutique",
  txt_xinzenmd: 'Ajouter',
  txt_qtxmdmc: "Éditer l'information de boutique",
  txt_qxzmddz: "Veuillez sélectionner l'adresse de boutique",
  txt_qtxxdz: 'Veuillez remplir l’adresse du magasin',
  txt_xiangxidz: 'Adresse détaillée',
  txt_qtxmddh: 'Veuillez saisir le numéro de téléphone de boutique',
  txt_dzxx: 'Information du gestionnaire',
  txt_chaungjianmendian: 'Créer une boutique',
  txt_mendianxxxx: 'Informations détaillées',
  txt_bianji: "Éditer l'information de boutique",
  txt_mendianzt: 'Etat de boutique',

  //商户数据总览
  txt_mendianshuju: 'Stockage des données',
  txt_chakangdxxbb: 'Vérifiez d’autres rapports',
  txt_jczcs: 'Contrôle Total',
  txt_mdpjjc: 'Inspection moyenne',
  txt_jdzcl: 'Flux Total de véhicules',
  txt_jcl: 'Taux d’inspection',
  txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
  txt_xyghltjgfb: '需更换轮胎的结果分布',
  txt_xzzyltjgfb: '需注意轮胎的结果分布',
  txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
  txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
  txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
  txt_jrzl: 'Vue d’ensemble',
  txt_xiangqbb: 'Détails',
  txt_xuanzerqckxxsj: 'Sélectionner date',
  txt_qxzsjd: 'Durée',
  txt_sjdts: 'Vous pouvez choisir une période inférieure à 30 jours',
  txt_zonglan: 'Vue d’ensemble',
  txt_qushi: 'Tendance',
  txt_shuliangtj: 'Statistiques quantitatives',
  txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
  txt_mslttsfb: '磨损轮胎条数分布情况',
  txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
  txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
  txt_sldwfbqk: '四轮定位结论条数分布情况',
  txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
  txt_jccsqs: 'Evolution du nombre d’inspections',
  txt_msqkslqs: 'Tendance à l’usure des pneus',
  txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
  txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
  txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
  txt_jccs: 'Contrôle Total',
  txt_shuliang: "Q'ty",
  txt_zhanbi: '%',
  txt_chankangd: 'Plus',
  txt_chakanmdxxbb: 'Détails',


  //国家
  txt_zhongguo: '中国',
  txt_mlxy: '马来西亚',
  txt_yindu: '印度',
  txt_taiguo: '泰国',
  txt_oluosi: '俄罗斯',



  txt_taici: 'Véhicules',
  txt_jianyi: 'Suggestion:',
  txt_jianyineirong: 'Usure inégale et interchange des pneus, veuillez vérifier davantage',
  txt_jianyineirongzc: 'Normal',
  txt_bgtixing: 'Rappel:',
  txt_bgtuxubfnr: "Selon l'usure des pneus, la distance de freinage est augmentée de {0}% (estimée)",
  txt_waishang: 'Dommage de pneu',
  txt_laohua: 'Vieillissement',
  txt_gubao: 'Renflement',
  txt_xichemeirong: 'Lavage&Beauté automobile',
  txt_weixiubaoyang: 'Maintenance',
  txt_guenghuanluntai: 'Maintenance',
  txt_scsltjcy: 'Détecteur de pneus portatif',
  txt_shijiantishi: 'Le début doit être plus rapide que la fin',

  txt_qxzclry: 'Seleziona un responsabile',

  txt_lf_outworn: 'Le côté extérieur du pneu AVG est plus usé que le côté intérieur.',
  txt_lf_innerworn: 'Le côté intérieur du pneu AVG est plus usé que le côté extérieur.',
  txt_lf_bothsideworn: 'Les deux côtés du pneu AVG sont plus usés que le centre',
  txt_lf_centreworn: 'Le centre du pneu AVG est plus usé que les deux côtés',
  txt_lb_outworn: 'Le côté extérieur du pneu ARG est plus usé que le côté intérieur.',
  txt_lb_innerworn: 'Le côté intérieur du pneu ARG est plus usé que le côté extérieur.',
  txt_lb_bothsideworn: 'Les deux côtés du pneu ARG sont plus usés que le centre',
  txt_lb_centreworn: 'Le centre du pneu ARG est plus usé que les deux côtés',
  txt_rb_outworn: 'Le centre du pneu ARG est plus usé que les deux côtés',
  txt_rb_innerworn: 'Le côté intérieur du pneu ARD est plus usé que le côté extérieur.',
  txt_rb_bothsideworn: 'Les deux côtés du pneu ARD sont plus usés que le centre',
  txt_rb_centreworn: 'Le centre du pneu ARD est plus usé que les deux côtés',
  txt_rf_outworn: 'Le côté extérieur du pneu AVD est plus usé que le côté intérieur.',
  txt_rf_innerworn: 'Le côté intérieur du pneu AVD est plus usé que le côté extérieur.',
  txt_rf_bothsideworn: 'Les deux côtés du pneu AVD sont plus usés que le centre',
  txt_rf_centreworn: 'Le centre du pneu AVD est plus usé que les deux côtés',
  txt_tire_need_replace: 'Usure du pneu, remplacez immédiatement',
  txt_tire_boundary: 'A la limite par usure du pneu',
  'txt_tire_boundary;': 'A la limite par usure du pneu',
  txt_alignment_chassis: "Il est recommandé de vérifier l'alignement de 4-roues ou le châssis",
  txt_wear_uniform: "Usure uniforme d'un pneu",
  'txt_wear_uniform;': "Usure uniforme d'un pneu",
  txt_do_further_check: 'Veuillez vérifier davantage',
  txt_uneven_check: 'Usure inégale, veuillez vérifier davantage',
  'txt_uneven_check;': 'Usure inégale, veuillez vérifier davantage',
  txt_tire_rotation: "Il est recommandé d'interchanger les pneus",
  txt_wear_normal: 'Normal',
  'txt_wear_normal;': 'Normal',
  txt_tire: 'Pneu',
  txt_xiazai: 'Télécharger',
  txt_xiazaishibai: 'Échec du téléchargement',
  txt_fanhui: 'Retour',
  txt_yszc: 'Accord de confidentialité',
  txt_djtyjbsydty: 'En cliquant sur accepter, vous reconnaissez avoir lu et accepté',
  txt_djyszc: '《Accord de confidentialité》',
  txt_tongyi: 'Agréer',
  txt_btongyi: 'Est en désaccord',
  txt_yszcnr: '[veuillez noter que] si vous n’êtes pas d’accord avec l’accord ci-dessus ou avec l’une des conditions qui y sont convenues, veuillez cesser votre inscription.  Vous ne pouvez pas profiter de nos services après avoir cessé votre inscription.  Si vous remplissez les informations conformément au processus d’inscription, après avoir lu et cliqué sur l’accord ci-dessus et après avoir terminé tout le processus d’inscription, vous déclarez que vous avez pleinement lu, compris et accepté l’accord dans son intégralité.  ',
  txt_qsrszcs: '请输入所在城市',
  txt_qsrszsf: '请输入所在省份',
  txt_qwsxx: '请完善信息',
  txt_shujufx: '数据分享',
  txt_fenxiang: '分享',
  txt_djxybbs: '点击下一步表示你已阅读并同意',
  txt_yhxy: '《用户协议》',
  txt_xxfxsz: 'Réglage',
  txt_jsfzh: '接收方账号',
  txt_xzfxxx: '选择分享信息',
  txt_jianceliang: '检测量',
  txt_fenxiangjieshu: '分享结束时间',
  txt_jieshou: '接收',
  txt_jujue: '拒绝',
  txt_jieshoufenxiang: '接受分享',
  txt_jieshoushanghu: '接收商户:',
  txt_zhongzhi: '终止',
  txt_fenxiangzhong: '分享中',
  txt_fenxiangshanghu: '分享商户',
  txt_jieshouzhong: '接收中',
  txt_sousuo: '搜索',
  txt_jiance: 'Détection',

  txt_fenxiangtishi: '对方没有分享此数据给您，无权查看',


  //报告新增 
  'txt_tire_age_8': 'Il est recommandé de procéder à un contrôle complet des pneumatiques qui sont en service depuis plus de 8 ans',
  'txt_tire_age_6': 'Il est recommandé de procéder à un contrôle complet des pneumatiques qui sont en service depuis plus de 6 ans',
  'txt_tire_age_5': 'Il est recommandé de procéder à un contrôle complet des pneumatiques qui sont en service depuis plus de cinq ans',
  'txt_tire_age_3': 'Il est recommandé de procéder à un contrôle complet des pneumatiques qui sont en service depuis plus de trois ans',
  'txt_tire_age_ok': 'L’âge des pneumatiques est normal',
  'txt_tire_age_ok;': 'L’âge des pneumatiques est normal',
  'txt_tire_trauma_check': 'La surface du pneumatique présente un traumatisme et un examen supplémentaire est recommandé',
  'txt_install_abnormal_check': 'Montage anormal du pneumatique, un contrôle supplémentaire est recommandé',
  'txt_tire_appearance_ok': 'Les pneus ont une bonne apparence',
  'trauma_lacerate': 'Couper',
  'trauma_dropblock': 'DiaoKuai',
  'trauma_puncture': 'Ponction',
  'trauma_scratch': 'Contusions',
  'txt_tire_age': 'Âge du pneumatique',
  'txt_tire_appearance': 'Aspect du pneumatique',
  txt_plcl: 'Batch',
  txt_qbxz: 'All',
  txt_scjcjg: 'Last',
  txt_ltxhlcgs: 'Tire range estimation',
  txt_ltazhuang: 'Installation:',
  txt_wear_overall: 'Usure globale',
  txt_pattern_wear: 'Usure inégale',
  txt_ltlcgstm: "Compte tenu de l 'usure actuelle du pneu, la durée de renouvellement du pneu est {0} km (estimation préliminaire)",

  txt_yichang: 'Anomalie',
  txt_qjybjcltazqk: "Vérifiez l'installation des pneus.",
  txt_dottx: "Rappel de temps d 'utilisation dot",
  txt_dottxjy: 'Les pneus sont utilisés depuis plus de trois ans. Vérifiez régulièrement',
  txt_danweinian: '(Unité:Année)',
  txt_danweikm: '(Unité:km)',
  txt_shurujb: "Saisissez ’Délier‘ pour désactiver le dispositif",
  txt_shuruzqwa: "Appuyez sur l 'icône pour saisir le texte.",
  txt_myhqdsj: 'Pas de temps DOT',
  txt_dotjstx: "il reste {0} jours pour les pneus.",
  txt_dotjstx2: 'Les pneus ont plus de 5 ans. Veuillez les remplacer immédiatement.',
  txt_dotsjztx: '(DOT heure:date de fabrication du pneu)',
  
  txt_gelie: 'Couper',
  txt_diaokuai: 'Perdre un morceau',
  txt_chaungci: 'Ponction',
  txt_cashang: 'égratignure',
  txt_yichang: 'Anomalie',
  'txt_tire_need_replace;': 'Usure du pneu, remplacez immédiatement',

  //未翻译
  txt_jishimz: 'Technicien',
  txt_ltlcgsnew: 'La distance de renouvellement du pneu est {0}',
  txt_ltlcgsnewin: 'Tire range is {0} miles',
  txt_msjxtx:'Les pneus ont atteint leur limite. Veuillez les remplacer immédiatement',
  txt_ltfz:'Intérieur et extérieur',
  
  txt_pinnate_check: 'Les pneus sont en forme de plume. Vérifiez.',
  txt_pinnate_wear: 'Abrasion plume',
 
  txt_install_check: "Vérification d 'installation",
  txt_install_ok:'Installation normale',
  LF:'[L-F]',
  RF:'[R-F]',
  LB:'[L-R]',
  RB:'[R-R]',
  FF:'[F-F]',
  BB:'[B-B]',
  txt_appearance_check:'Anomalie du pneu',
  txt_uneven_center:"Anomalie d 'usure au milieu du pneu",
  txt_uneven_out:"Anomalie d 'usure du flanc extérieur du pneu",
  txt_pinnate_check:"L 'usure des pneus en plume suggère un examen plus poussé de la plaque de châssis",
  txt_uneven_inside :"Anomalie d 'usure latérale interne du pneu",
  txt_uneven_bothside:"Anomalie d 'usure des deux côtés du pneu, il est recommandé de vérifier le positionnement des quatre roues et la pression du pneu.",

  txt_msyzljgh:'Les pneus sont très usés, veuillez les remplacer immédiatement.',
  txt_serious_trauma_check:"Les pneus sont gravement traumatisés.",
  txt_appearance_lookup:"Vérifiez l'apparence des pneus.",
  txt_wear_lookup :"Vérifiez l'usure des pneus.",
  txt_dotscsj:"Temps de production: {0} ({1} semaine {2} de l 'année)",
  txt_whqdscsj:'Pas de temps de production',
  purp_tireservice:'Service de pneus',
  purp_vehicle_inspection:'Inspection des véhicules', 
  txt_chassis_check :'Contrôle de châssis',
  txt_chassis_ok:'Le châssis est bien vérifié.',
  txt_chassis_oil:"Fuites d'huile dans l'amortisseur, il est recommandé de confirmer ces fuites et de les remplacer si nécessaire.",
  txt_chassis_aging :"Le caoutchouc d 'arbre vieillit et il est recommandé de le remplacer.",
  txt_hood:'CAPOT MOTEUR',
  txt_wash_liquid:'LIQUIDE LAVE-VITRES',
  txt_level_control:'CONTRÔLE DU NIVEAU',
  txt_haoxiaoxi:'OK:Bonne nouvelle',
  txt_vedi_Note:'LIRE NOTE:Planification des travaux',
  txt_replace1:"REMPLACER: S'entendre sur un travail immédiat",
  txt_radiator_fluid:'LIQUIDE DE RADIATEUR',
  txt_engine_oil:'HUILE DU MOTEUR',
  txt_brake_fluid:'LIQUIDE DES FREINS ',
  txt_quality_control:'CONTRÔLE QUALITÉ',
  txt_multimeter:'TEST MULTIMÈTRE',
  txt_subtotal:'SOUS CHASSIS',
  txt_shock_absorber:'AMORTISSEURS',
  txt_check_loss:'CONTRÔLE DES FUITES VISIBLES',
  txt_brake_disc:'DISQUES DES FREINS',
  txt_wear_condition:"ÉTAT D'USURE",
  txt_brake_pads:'LES PLAQUETTES DE FREIN',
  txt_change_control:'AUTRES CONTROLES',
  txt_air_control:'CLIMATISATION',
  txt_last_reload:'DERNIÈRE RECHARGE',
  txt_lighting:'FEUX',
  txt_verification1:'ESSUIE-GLACE',
  txt_dynamometer:'SERRAGE AVEC DYNAMOMÈTRE FAIT PAR',
  txt_batteria:'BATTERIE',
  txt_verification:'CONTRÔLE DU FONCTIONNEMENT',
  txt_levellow:'Ok',
  txt_levelmiddle:'Read note',
  txt_levelhigh:'Replace',
  txt_tyrenumber:'Profondeur de balayage:',
  txt_cormach_title:'Usure&Usure excentrique',
  txt_wearlow:'Normal',
  txt_wearmiddle:'Légère usure',
  txt_wearhigh:'Usure sévère',
  txt_namtishi:'Tread Depth in 32nds',
  txt_zhiliangkongzhi:'Contrôle de la qualité',
  txt_buchongzhengduan:'Diagnostic Complémentaire',
  txt_season_summer:"Pneu Été",
  txt_season_winter:'Pneu Hiver',
 //
  txt_trauma_eattyre:'pneu - mangeur',
  txt_uneven_eattyre:'les pneus mangent les pneus, l’équilibrage dynamique est recommandé et l’alignement des roues, le système de suspension sont vérifiés',
  txt_appearance_eattyre:'les pneus mangent les pneus, l’équilibrage dynamique est recommandé et l’alignement des roues, le système de suspension sont vérifiés',
  txt_chassis_eattyre:'le pneu mange le pneu, il est recommandé de vérifier l’alignement des quatre roues, le système de suspension',
  txt_uneven_high_eattyre:"les pneus mangent lourdement, il est recommandé de les remplacer et de vérifier l'alignement des roues, le système de suspension",
  txt_appearance_high_eattyre:'le pneu est fortement mangé, l’équilibrage dynamique est recommandé et l’alignement des roues, le système de suspension sont vérifiés',
  txt_chassis_high_eattyre:'le pneu est fortement mangé, il est recommandé de vérifier l’alignement des quatre roues, le système de suspension',
  txt_chassis_uneven:"usure excentrique anormale des pneus, il est recommandé de vérifier l'alignement des quatre roues, le système de suspension",
  txt_pianmoyichang:'usure anormale du pneu',


  txt_khxm:'nom du client',
  txt_khyx:'boîte aux lettres du client',
  
}


// WEBPACK FOOTER //
// ./src/i18n/french.js